<script setup lang="ts">
import MsgMineMenu from "@/views/ChatMessage/MsgMineMenu.vue";
import { isCompactMode } from "@/data/pubilc";
import { defineProps, toRefs } from "vue";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";

const props = defineProps({
  msgObj: {
    type: Object,
    required: true,
  },
});

const { msgObj } = toRefs(props);

const menuAction = (index: number) => {
  //0 copy 1 edit
  if (index === 0) {
    ElMessage.success("已复制");
    Clipboard.copy(msgObj.value.content);
  } else {
    //
  }
};
</script>

<template>
  <div class="msg-base">
    <div class="body" :class="{ 'compact-body': isCompactMode }">
      <el-popover
        placement="left-start"
        :width="80"
        trigger="hover"
        :show-arrow="false"
        popper-class="my-popper"
      >
        <template #reference>
          {{ msgObj.content }}
        </template>
        <MsgMineMenu @menuAction="menuAction" />
      </el-popover>
      <div class="body-img" v-if="msgObj.url">
        <el-image
          style="width: 170px; height: auto"
          :src="msgObj.url"
          :zoom-rate="1.2"
          :max-scale="7"
          :min-scale="0.2"
          :preview-src-list="[msgObj.url]"
          show-progress
          :initial-index="4"
          fit="cover"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.msg-base {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row-reverse;
  user-select: text;
  .body {
    padding: 12px 16px;
    overflow: hidden;
    background-color: #eff6ff;
    border-radius: 24px;
    font-size: 16px;
    :deep(.el-popover .el-popper) {
      box-shadow: none !important;
    }

    .body-img {
      margin-top: 4px;
      overflow: hidden;
      border-radius: 4px;
      max-width: 170px;
    }
  }

  .compact-body {
    padding: 12px 10px;
  }
}

.my-popper {
  box-shadow: none !important;
  border: none !important;
  padding: 0 !important;
  background: none !important;
  margin-top: -6px;
}
</style>
